import Text from "common/Typography/Text";
import Modal from "common/Modal/Modal";
import React, { useContext } from "react";
import { OnboardingStyles } from "features/onboarding/common/styles";
import SubmitButton from "features/onboarding/common/SubmitButton";
import { ConfirmBulkEditModalProps } from "@shared/features/onboarding/types";
import Flex from "common/Boxes/Flex";
import Button from "common/Buttons/Button";
import { typography } from "@shared/common/Themes/typography";
import pluralize from "pluralize";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import { BOT_FORM_CONFIRM_BULK_EDIT_CONTINUE_BUTTON_ID } from "testIds.ts";

const ConfirmBulkEditModal = ({
  isVisible,
  content,
  onOk,
  onCancel,
  buttonLoading,
  title,
  numValidBots,
  numInvalidBots,
}: ConfirmBulkEditModalProps) => {
  const { botFormType } = useContext(BotFormContext)!;
  const isBulkCreate = botFormType === BotFormType.BULK_CREATE;

  const getNumEditedText = () => {
    return (
      <Text>
        <span style={{ fontWeight: typography.fontWeights.MEDIUM }}>
          {numValidBots} {pluralize("Bot", numValidBots)} will be{" "}
          {isBulkCreate ? "created" : "edited"}
        </span>
        {!!numInvalidBots && (
          <>
            {" "}
            and{" "}
            <span style={{ fontWeight: typography.fontWeights.MEDIUM }}>
              {numInvalidBots} {pluralize("Bot", numInvalidBots)} will not be{" "}
              {isBulkCreate ? "created" : "changed"}.
            </span>
          </>
        )}
      </Text>
    );
  };

  return (
    <Modal
      open={isVisible}
      footer={false}
      width={450}
      styles={{ body: { padding: 32, textAlign: "center" } }}
      onCancel={onCancel}
    >
      <OnboardingStyles.ModalTitle style={{ marginBottom: 16 }}>
        {title}
      </OnboardingStyles.ModalTitle>
      <Text>{content?.[0]}</Text>
      {getNumEditedText()}
      <Text>{content?.[1]}</Text>
      <Flex style={{ marginTop: 28, columnGap: 16 }}>
        <Button
          $type="secondary"
          $size="l"
          onClick={onCancel}
          style={{ flex: 1 }}
        >
          Cancel
        </Button>
        <SubmitButton
          data-testid={BOT_FORM_CONFIRM_BULK_EDIT_CONTINUE_BUTTON_ID}
          onClick={onOk}
          loading={buttonLoading}
          style={{ flex: 1, margin: 0 }}
        >
          Continue
        </SubmitButton>
      </Flex>
    </Modal>
  );
};

export default ConfirmBulkEditModal;
